import { useEffect, useState } from "react";
import { api, formatPrice } from "@/lib/api";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <div className="font-heading text-3xl font-black uppercase tracking-tight">Clients</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />
      <div className="bg-ink-900 border border-ink-700 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-ink-800 text-zinc-400 uppercase text-xs">
            <tr><th className="text-left px-4 py-3">Nom</th><th className="text-left px-4 py-3">Téléphone</th><th className="text-left px-4 py-3">Email</th><th className="text-right px-4 py-3">Demandes</th><th className="text-right px-4 py-3">Total</th><th className="text-left px-4 py-3">Dernière</th></tr>
          </thead>
          <tbody className="divide-y divide-ink-700">
            {rows.map((c, i) => (
              <tr key={i} className="hover:bg-ink-800">
                <td className="px-4 py-3 font-semibold">{c.name || "—"}</td>
                <td className="px-4 py-3">{c.phone}</td>
                <td className="px-4 py-3">{c.email || "—"}</td>
                <td className="px-4 py-3 text-right">{c.request_count}</td>
                <td className="px-4 py-3 text-right">{formatPrice(c.total_spent)}</td>
                <td className="px-4 py-3 text-zinc-500 text-xs">{(c.last_request || "").slice(0, 16).replace("T", " ")}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={6} className="text-center py-8 text-zinc-500">Aucun client</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
